import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, TipoDocumento, SaveTipoDocumentoDto, SearchTipoDocumentoRequest } from "../model/index";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})
export class TipoDocumentoService extends CrudService<TipoDocumento, number, SaveTipoDocumentoDto, SearchTipoDocumentoRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'tipoDocumento', sharedFunctions);

  }

  getAnonymousList(): Observable<GenericResponse<TipoDocumento[]>> {
    return this._http.get<GenericResponse<TipoDocumento[]>>(this._serviceUrl+"/anonymous", this.httpOptions);
  }
}